const isBrowser = typeof window !== 'undefined';

export const isLocalhost = isBrowser
  ? window.location.hostname === 'localhost'
  : process.env.NODE_ENV === 'development';

export const baseURL = process.env.MONUS_API_URL;
//isLocalhost
//? process.env.MONUS_EMULATOR
//: process.env.MONUS_API_URL;

import { auth } from 'db/config';

async function makeRequest(method, path, body = null) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (auth.currentUser) {
    const token = await auth.currentUser.getIdToken();
    options.headers['Authorization'] = `Bearer ${token}`;
  }
  if (body) {
    options.body = JSON.stringify(body);
  }

  return fetch(baseURL + path, options);
}

export const get = (path) => {
  return makeRequest('GET', path);
};

export const post = (path, body) => {
  return makeRequest('POST', path, body);
};

export const put = (path, body) => {
  return makeRequest('PUT', path, body);
};

export const del = (path) => {
  return makeRequest('DELETE', path);
};
